import React, {useCallback, useContext, useEffect, useState} from 'react';

import {
    Avatar,
    Box,
    Button,
    ButtonGroup,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CardMedia,
    Checkbox,
    Chip,
    Collapse,
    FormControl,
    FormControlLabel,
    InputLabel,
    ListItem,
    ListItemAvatar,
    MenuItem, Paper,
    Select,
    Switch,
    Tab,
    TextField,
    ToggleButton,
    ToggleButtonGroup
} from '@mui/material';

import {DateCalendar, DayCalendarSkeleton, PickersDay, TimePicker} from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import Activity from "../../../MasterEventObjects/Activity";
import PALocation from "../../../MasterEventObjects/Location";
import {PAContext} from "../../../Services/PAContext";
import './activities.css';

import {useNavigate} from "react-router-dom";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {formatName, stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import TabList from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import ActivityAddLocationTab from "./ActivityAddLocationTab";
import Typography from "@mui/material/Typography";
import {
    useGoogleAutocompleteUniversal
} from "../../Helpers/GoogleAutocomplete";
import {daysOfWeekMap} from "../../Helpers/DatesAndTimes";
import IconButton from "@mui/material/IconButton";
import {useDropzone} from "react-dropzone";
import {Stack} from "@mui/system";
import PAAttendee from "../../../MasterEventObjects/Attendee";
import Photo from "../../../MasterEventObjects/Photo";

import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";
import {addEventPhoto} from "../Photos/BrowserDatabaseFunctions";

const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]; // Weekday names



function ActivitiesAddNew(props) {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated } = dataArray; // Fetch event attendees

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [eventHasDates, setEventHasDates] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);
    const [eventHasDays, setEventHasDays] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);



    // State management for the new Activity
    const [activity, setActivity] = useState(new Activity());
    const [activityTitle, setActivityTitle] = useState("");

    function handleActivityTitleChange(e){
        setActivityTitle(e.target.value);
    }

    const [isScheduled, setIsScheduled] = useState(true); // Toggle for all-day activity
    const [allDay, setAllDay] = useState(true); // Toggle for all-day activity
    const [selectTimeToggle, setSelectTimeToggle] = useState(false); // Toggle for all-day activity

    const planningDates = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table.dates || [];

    const [ selectedActivityDates, setSelectedActivityDates ] = useState([]);
    const [selectedActivityBeginDate, setSelectedActivityBeginDate] = useState(
        planningDates.length > 0 && planningDates[0].date ? dayjs(planningDates[0].date) : null
    );
    const [selectedActivityEndDate, setSelectedActivityEndDate] = useState(
        planningDates.length > 0 && planningDates[0].date ? dayjs(planningDates[0].date) : null
    );
    const [ selectedActivityDays, setSelectedActivityDays ] = useState([]);
    const [selectedActivityBeginDay, setSelectedActivityBeginDay] = useState(() => {
        const firstDay = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table.days?.[0];
        return firstDay ? { day_index: Object.keys(firstDay)[0], day: Object.values(firstDay)[0] } : null;
    });
    const [selectedActivityEndDay, setSelectedActivityEndDay] = useState(() => {
        const firstDay = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table.days?.[0];
        return firstDay ? { day_index: Object.keys(firstDay)[0], day: Object.values(firstDay)[0] } : null;
    });
    const [activityDaysCount, setActivityDaysCount] = useState(1);
    const [activityStartingOnDay, setActivityStartingOnDay] = useState('');


    const planningTimeTable = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table;

    const rawBeginTime =
        planningTimeTable?.dates?.[0]?.begin_time ||
        planningTimeTable?.days?.[0]?.begin_time ||
        null;

    const rawEndTime =
        planningTimeTable?.dates?.[planningTimeTable.dates.length - 1]?.end_time ||
        planningTimeTable?.days?.[planningTimeTable.days.length - 1]?.end_time ||
        null;

    const [selectedActivityBeginTime, setSelectedActivityBeginTime] = useState(
        rawBeginTime ? dayjs(rawBeginTime, 'h:mm A') : null
    );

    const [selectedActivityEndTime, setSelectedActivityEndTime] = useState(
        rawEndTime ? dayjs(rawEndTime, 'h:mm A') : null
    );

    const [tabValueSchedule, setTabValueSchedule] = useState(eventHasDates || !eventHasDays ? "dates" : "days");
    const handleTabScheduleChange  = (event, newValue) => {
        console.log("handleTabScheduleChange ");
        setTabValueSchedule(newValue);
    };

    const [calendarDate, setCalendarDate] = useState(() => {
        const initialDates = PA_GlobalObject.Planning['time_table'].dates;

        if (initialDates.length === 0) {
            return dayjs(); // Fallback: no dates available
        }

        const today = dayjs().startOf('day');
        const matchingDate = initialDates.find(d =>
            dayjs(d.date, "YYYY-MM-DD").isSame(today, 'day')
        );

        return matchingDate
            ? dayjs(matchingDate.date, "YYYY-MM-DD")
            : dayjs(initialDates[0].date, "YYYY-MM-DD");
    });
    function getMarkersForDate(date, _planning) {

        const markers = [];

        // Check for meals
        const mealDates = _planning.meals.flatMap((entry) => {
            const _time_table = entry.time_table;
            return _time_table.dates.map((item) => dayjs(item.date, "YYYY-MM-DD")); // Return dayjs objects
        });
        if (mealDates?.some((mealDate) => mealDate.isSame(date, "day"))) {
            markers.push("meal");
        }

        // Check for lodging
        const lodgingDates = _planning.lodging.flatMap((entry) => {
            const _time_table = entry.time_table;
            return _time_table.dates.map((item) => dayjs(item.date, "YYYY-MM-DD")); // Return dayjs objects
        });
        if (lodgingDates?.some((lodgingDate) => lodgingDate.isSame(date, "day"))) {
            markers.push("lodging");
        }

        // Check for activities
        const activityDates = _planning.activities.flatMap((entry) => {
            const _time_table = entry.time_table;
            return _time_table.dates.map((item) => dayjs(item.date, "YYYY-MM-DD")); // Return dayjs objects
        });
        if (activityDates?.some((activityDate) => activityDate.isSame(date, "day"))) {
            markers.push("activity");
        }

        return markers;
    }
    function isHighlighted(date, _planning) {
        // Check if the provided date exists in the selectedDates array
        return selectedActivityDates.some(dateEntry => dateEntry.date === date.format('YYYY-MM-DD'));
    }
    function ServerDay(props) {
        const { day, outsideCurrentMonth, planningData, ...other } = props;

        const isSelected = isHighlighted(dayjs(day));
        const markers = getMarkersForDate(dayjs(day), planningData); // Get markers for the current day

        // Check if the current day is part of the event's base time_table.dates
        const eventDates = planningData?.time_table?.dates?.map(d => dayjs(d.date, "YYYY-MM-DD")) || [];
        const isEventDate = eventDates.some(eventDay => eventDay.isSame(day, "day"));

        return (
            <PickersDay
                {...other}
                outsideCurrentMonth={outsideCurrentMonth}
                day={day}
                onClick={() => handleDateClick(day)}
                sx={{
                    ...(isSelected
                        ? {
                            backgroundColor: "#1976d2 !important", // Blue circle for selected
                            color: "white", // Ensure date text remains white
                            borderRadius: "50%",
                        }
                        : {
                            backgroundColor: "#fff !important",
                            color: outsideCurrentMonth ? "#ccc" : "rgb(0, 0, 0, .8) !important", // Default color for text
                            border: dayjs().isSame(dayjs(day), 'day') ? '1px solid #1976d2' : 'none',
                        }),
                    position: "relative", // Allow absolute positioning for markers
                    borderBottom: isEventDate ? "2px solid #1976d2" : "none",
                }}
            >

                <span>{day.format("D")}</span>

                {/* Render dots for markers */}
                {markers.length > 0 && (
                    <div
                        style={{
                            position: "absolute",
                            top: "4px", // Position dots near the top
                            right: "4px", // Align dots to the right
                            display: "flex",
                            gap: "3px", // Space between dots
                        }}
                    >
                        {markers.map((marker, index) => (
                            <span
                                key={index}
                                style={{
                                    width: "5px",
                                    height: "5px",
                                    borderRadius: "50%",
                                    backgroundColor:
                                        marker === "meal"
                                            ? "#FF6347" // Red for meals
                                            : marker === "lodging"
                                                ? "#32CD32" // Green for lodging
                                                : "#FFD700", // Yellow for activities
                                }}
                            ></span>
                        ))}
                    </div>
                )}
            </PickersDay>
        );
    }

    const handleDateClick = (_date) => {
        const formattedDate = _date.format('YYYY-MM-DD');

        setSelectedActivityDates((prev) => {
            const exists = prev.some(entry => entry.date === formattedDate);
            let updated;

            if (exists) {
                // Remove the date
                updated = prev.filter(entry => entry.date !== formattedDate);
            } else {
                // Add the new date
                updated = [
                    ...prev,
                    {
                        date: formattedDate,
                        "all-day": true,
                        begin_time: null,
                        end_time: null
                    }
                ];
            }

            // Sort chronologically
            const sorted = updated.sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix());

            // Rebuild structure if in multi-day mode
            if (timeMode === 'multi-day') {
                if (sorted.length < 2 || !areDatesConsecutive(sorted)) {
                    setTimeMode('all-day');
                    return sorted;
                }

                const beginTime = selectedActivityBeginTime?.format('h:mm A') || null;
                const endTime = selectedActivityEndTime?.format('h:mm A') || null;

                return sorted.map((entry, index) => {
                    if (index === 0) {
                        return { ...entry, "all-day": false, beginTime, endTime: null };
                    } else if (index === sorted.length - 1) {
                        return { ...entry, "all-day": false, beginTime: null, endTime };
                    } else {
                        return { ...entry, "all-day": true, beginTime: null, endTime: null };
                    }
                });
            }


            // Rebuild structure if in per-day mode
            //so for this there needs to be an entry for each date with the specific times
            if (timeMode === 'per-day') {
                const begin_time = selectedActivityBeginTime?.format('h:mm A') || null;
                const end_time = selectedActivityEndTime?.format('h:mm A') || null;

                return sorted.map(entry => ({
                    ...entry,
                    "all-day": false,
                    begin_time,
                    end_time
                }));
            }

            console.log("sorted : ", sorted);

            return sorted;
        });
    };

    useEffect(() => {
        console.log("selectedActivityDates", selectedActivityDates);
    }, [selectedActivityDates]);

    const handleActivityDaysChange = (dayIndex, dayName) => {

        setSelectedActivityDays(prev => {
            const exists = prev.some(day => {
                const key = Object.keys(day).find(k => k.startsWith('day '));
                return key === dayIndex;
            });
            let updated;

            if (exists) {
                // Remove the day
                updated = prev.filter(day => {
                    const key = Object.keys(day).find(k => k.startsWith('day '));
                    return key !== dayIndex;
                });
            } else {
                // Add the new day (initialize time structure)
                updated = [
                    ...prev,
                    {
                        [dayIndex]: dayName,
                        "all-day": true,
                        begin_time: null,
                        end_time: null,
                        notes:""
                    }
                ];
            }

            // ✅ Sort using extracted numeric index
            const sorted = [...updated].sort((a, b) => {
                const aKey = Object.keys(a).find(k => k.startsWith("day "));
                const bKey = Object.keys(b).find(k => k.startsWith("day "));
                const aIndex = aKey ? parseInt(aKey.replace('day ', ''), 10) : 0;
                const bIndex = bKey ? parseInt(bKey.replace('day ', ''), 10) : 0;
                return aIndex - bIndex;
            });

            console.log("sorted : ", sorted);

            // Time handling logic based on timeMode
            if (timeMode === 'per-day') {
                const begin_time = selectedActivityBeginTime?.format('h:mm A') || null;
                const end_time = selectedActivityEndTime?.format('h:mm A') || null;

                return sorted.map(entry => ({
                    ...entry,
                    "all-day": false,
                    begin_time,
                    end_time
                }));
            }

            if (timeMode === 'multi-day') {
                if (sorted.length < 2 || !areDayIndexesConsecutive(sorted)) {
                    setTimeMode('all-day');
                    return sorted;
                }

                const beginTime = selectedActivityBeginTime?.format('h:mm A') || null;
                const endTime = selectedActivityEndTime?.format('h:mm A') || null;

                return sorted.map((entry, index) => {
                    if (index === 0) {
                        return { ...entry, "all-day": false, begin_time: beginTime, end_time: null };
                    } else if (index === sorted.length - 1) {
                        return { ...entry, "all-day": false, begin_time: null, end_time: endTime };
                    } else {
                        return { ...entry, "all-day": true, begin_time: null, end_time: null };
                    }
                });
            }

            return sorted;
        });
    };

    useEffect(() => {
        console.log("selectedActivityDays", selectedActivityDays);
    }, [selectedActivityDays]);

    const areDatesConsecutive = (dates) => {
        console.log("---------------areDatesConsecutive", dates);
        const sorted = [...dates]
            .map(d => dayjs(d.date)) // assuming each has a `date` field
            .sort((a, b) => a.unix() - b.unix());

        console.log("areDatesConsecutive", sorted);

        for (let i = 1; i < sorted.length; i++) {

            console.log("areDatesConsecutive", sorted);
            if (!sorted[i - 1].add(1, 'day').isSame(sorted[i], 'day')) {
                console.log("return false");

                return false; // There's a gap
            }
        }
        return true;
    };
    function areDayIndexesConsecutive(days) {
        const indexes = days
            .map((d) => {
                const dayKey = Object.keys(d).find(key => key.startsWith('day '));
                if (!dayKey) return null;
                return parseInt(dayKey.replace('day ', ''), 10);
            })
            .filter((val) => val !== null)
            .sort((a, b) => a - b);

        if (indexes.length < 2) return false;

        return indexes.every((val, i, arr) => i === 0 || val === arr[i - 1] + 1);
    }


    const handleActivityDaysCountChange = (event) => {
        const newDaysCount = parseInt(event.target.value, 10);
        setActivityDaysCount(newDaysCount);

        if (isNaN(newDaysCount) || newDaysCount <= 0) return;

        const startDayIndex = daysOfWeekMap[activityStartingOnDay] ?? NaN;
        if (isNaN(startDayIndex)) return;

        const newSelectedDays = [];

        for (let i = 0; i < newDaysCount; i++) {
            const dayIndex = (startDayIndex + i) % 7;
            const dayName = dayjs().day(dayIndex).format('dddd');

            let isAllDay = true;
            let begin_time = null;
            let end_time = null;

            const hasValidBegin = selectedActivityBeginTime && dayjs(selectedActivityBeginTime).isValid();
            const hasValidEnd = selectedActivityEndTime && dayjs(selectedActivityEndTime).isValid();

            if (timeMode === 'per-day') {
                isAllDay = false;
                begin_time = hasValidBegin ? dayjs(selectedActivityBeginTime).format('h:mm A') : null;
                end_time = hasValidEnd ? dayjs(selectedActivityEndTime).format('h:mm A') : null;
            } else if (timeMode === 'multi-day') {
                if (i === 0) {
                    // First day: has begin time only
                    isAllDay = false;
                    begin_time = hasValidBegin ? dayjs(selectedActivityBeginTime).format('h:mm A') : null;
                } else if (i === newDaysCount - 1) {
                    // Last day: has end time only
                    isAllDay = false;
                    end_time = hasValidEnd ? dayjs(selectedActivityEndTime).format('h:mm A') : null;
                } else {
                    // Middle days: all-day true
                    isAllDay = true;
                }
            } else {
                // Default to all-day
                isAllDay = true;
            }

            newSelectedDays.push({
                [`day ${i + 1}`]: dayName,
                'all-day': isAllDay,
                'begin_time': begin_time,
                'end_time': end_time,
                'notes': "",
            });
        }

        setSelectedActivityDays(newSelectedDays);
    };
    function handleActivityStartingOnChange(event) {
        const newStartingDay = event.target.value;
        console.log("handleActivityStartingOnChange : " + newStartingDay);

        const newSelectedDays = [];

        const startDayIndex = daysOfWeekMap[newStartingDay] ?? NaN;
        if (isNaN(startDayIndex)) return;

        const hasValidBegin = selectedActivityBeginTime && dayjs(selectedActivityBeginTime).isValid();
        const hasValidEnd = selectedActivityEndTime && dayjs(selectedActivityEndTime).isValid();

        for (let i = 0; i < activityDaysCount; i++) {
            const dayIndex = (startDayIndex + i) % 7;
            const dayName = dayjs().day(dayIndex).format('dddd');

            let isAllDay = true;
            let begin_time = null;
            let end_time = null;

            if (timeMode === 'per-day') {
                isAllDay = false;
                begin_time = hasValidBegin ? dayjs(selectedActivityBeginTime).format('h:mm A') : null;
                end_time = hasValidEnd ? dayjs(selectedActivityEndTime).format('h:mm A') : null;
            } else if (timeMode === 'multi-day') {
                if (i === 0) {
                    isAllDay = false;
                    begin_time = hasValidBegin ? dayjs(selectedActivityBeginTime).format('h:mm A') : null;
                } else if (i === activityDaysCount - 1) {
                    isAllDay = false;
                    end_time = hasValidEnd ? dayjs(selectedActivityEndTime).format('h:mm A') : null;
                } else {
                    isAllDay = true;
                }
            } else {
                // all-day fallback
                isAllDay = true;
            }

            newSelectedDays.push({
                [`day ${i + 1}`]: dayName,
                'all-day': isAllDay,
                'begin_time': begin_time,
                'end_time': end_time,
                'notes': "",
            });
        }

        console.log("newSelectedDays : ", newSelectedDays);

        setSelectedActivityDays(newSelectedDays);
        setActivityStartingOnDay(newStartingDay);
    }

    // Time handling for begin and end times
    const handleBeginTimeChange = (newTime) => {
        setSelectedActivityBeginTime(newTime);

        setSelectedActivityDates(prevDates =>
            prevDates.map((entry, index) => {
                if (timeMode === 'multi-day') {
                    // Only set begin time on the first date
                    if (index === 0) return { ...entry, begin_time: dayjs(newTime).format('h:mm A') };
                    if (index === prevDates.length - 1) return { ...entry }; // endTime will be handled separately
                    return { ...entry, "all-day": true }; // middle dates
                }
                if (timeMode === 'per-day' || timeMode === 'all-day') {
                    return {
                        ...entry,
                        "all-day": false,
                        begin_time: dayjs(newTime).format('h:mm A') };
                }
                return entry;
            })
        );

        setSelectedActivityDays(prevDays =>
            prevDays.map((entry, index) => {
                if (timeMode === 'multi-day') {
                    // Only set begin time on the first day
                    if (index === 0) return { ...entry, begin_time: dayjs(newTime).format('h:mm A') };
                    if (index === prevDays.length - 1) return { ...entry }; // endTime will be handled separately
                    return { ...entry, "all-day": true }; // middle days
                }
                if (timeMode === 'per-day' || timeMode === 'all-day') {
                    return {
                        ...entry,
                        "all-day": false,
                        begin_time: dayjs(newTime).format('h:mm A') };
                }
                return entry;
            })
        );
    };
    const handleEndTimeChange = (newTime) => {
        setSelectedActivityEndTime(newTime);

        setSelectedActivityDates(prevDates =>
            prevDates.map((entry, index) => {
                if (timeMode === 'multi-day') {
                    // Only set end time on the last date
                    if (index === prevDates.length - 1) return { ...entry, end_time: dayjs(newTime).format('h:mm A') };
                    return entry;
                }
                if (timeMode === 'per-day' || timeMode === 'all-day') {
                    return {
                        ...entry,
                        "all-day": false,
                        end_time: dayjs(newTime).format('h:mm A') };
                }
                return entry;
            })
        );

        setSelectedActivityDays(prevDays =>
            prevDays.map((entry, index) => {
                if (timeMode === 'multi-day') {
                    // Only set end time on the last day
                    if (index === prevDays.length - 1) return { ...entry, end_time: dayjs(newTime).format('h:mm A') };
                    return entry;
                }
                if (timeMode === 'per-day' || timeMode === 'all-day') {
                    return {
                        ...entry,
                        "all-day": false,
                        end_time: dayjs(newTime).format('h:mm A') };
                }
                return entry;
            })
        );
    };

    // Toggle between showing time_table and not
    const handleIsScheduledToggle = (event) => {
        setIsScheduled(event.target.checked);
        if (!event.target.checked){
            //clear out all of the time_table info
            setSelectedActivityBeginDate(null);
            setSelectedActivityEndDate(null);
            setSelectedActivityBeginDay({});
            setSelectedActivityEndDay({});
        }
    };

    // Toggle between all-day and specific time activity
    const handleAllDayToggle = (event) => {
        setAllDay(event.target.checked);
        if (event.target.checked){
            setSelectedActivityEndTime(null);
            setSelectedActivityBeginTime(null);
        }
    };
    const  renderActivityDaysLayoutForBegin = () => {

        // Get all planned days from Planning.time_table.days
        const planningDays = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days || [];

        if (planningDays.length === 0) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        gap: '4px', // Small spacing between squares
                        paddingBottom: '20px',
                    }}
                >
                    {daysOfWeek.map((day, index) => (
                        <Box
                            key={index}
                            sx={{
                                flex: 1,
                                aspectRatio: '1 / 1', // Ensures square
                                maxWidth: 'calc((100% - 6 * 4px) / 7)', // Account for 6 gaps (4px each) between 7 items
                            }}
                        >
                            <Chip
                                label={
                                    <Typography variant="body2" textAlign="center">
                                        {day.slice(0, 2)}
                                    </Typography>
                                }
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 123, 255, 0.2)',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                clickable
                                onClick={() => handleActivityDaysChange(`day ${index + 1}`, day)}
                            />
                        </Box>
                    ))}
                </Box>
            );
        }

        // Create an array to store all possible day objects (even for multi-week events)
        const calendarDays = [];

        planningDays.forEach((dayObj, index) => {
            const dayKey = Object.keys(dayObj).find(k => k.startsWith('day ')); // e.g., 'day 1'
            const dayName = dayObj[dayKey]; // e.g., 'Wednesday'
            const dayOfWeekIndex = daysOfWeek.indexOf(dayName); // Index for Su-Sa layout (0-6)

            // Add the day to the correct slot (considering multiple weeks)
            calendarDays.push({
                key: dayKey,
                name: dayName,
                index: index + 1, // Index representing day in Planning (1-based index)
                isSelected: selectedActivityDays.some(d => Object.keys(d).find(k => k.startsWith('day ')) === dayKey) // Set the selected status based on the selectedActivityDay
            });
        });

        // Organize into weeks (rows of 7 days)
        const weeks = [];
        let currentWeek = Array(7).fill(null);

        calendarDays.forEach((dayObj) => {
            const dayOfWeekIndex = daysOfWeek.indexOf(dayObj.name);
            currentWeek[dayOfWeekIndex] = dayObj;

            // When the week is complete (Saturday), push the current week to the weeks array
            if (dayOfWeekIndex === 6) {
                weeks.push(currentWeek);
                currentWeek = Array(7).fill(null);
            }
        });

        // Push the final incomplete week if it exists
        if (currentWeek.some(day => day !== null)) {
            weeks.push(currentWeek);
        }

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingBottom: '20px' }}>
                {/* Iterate over weeks */}
                {weeks.map((week, weekIndex) => (
                    <Box
                        key={weekIndex}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center', // Centers the week layout
                            gap: '2px', // Small spacing between Chips
                        }}
                    >
                        {/* Iterate over each day in the week */}
                        {
                            week.map((day, dayIndex) => (
                                <Box
                                    key={dayIndex}
                                    sx={{
                                        flex: '1 1 calc(100% / 7 - 2px)',  // Ensures even width for each slot WITH SPACING
                                        maxWidth: '50px', // Prevents oversized Chips
                                        aspectRatio: '1', // Keeps it square
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {day ? (
                                        <Chip
                                            label={
                                                <Typography variant="body2" sx={{ textAlign: 'center' }}>
                                                    {day.name.slice(0, 2)}
                                                </Typography>
                                            }
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: selectedActivityDays.some(d => Object.keys(d).find(k => k.startsWith('day ')) === day.key)
                                                    ? 'rgba(0, 123, 255, 0.8) !important'
                                                    : 'rgba(0, 123, 255, 0.2) !important',
                                                borderRadius: '10px', // Rounded corners
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                            clickable
                                            onClick={() => handleActivityDaysChange(day.key, day.name)}
                                        />
                                    ) : (
                                        <Chip
                                            label={
                                                <Typography variant="body2" sx={{ textAlign: 'center', color:'#FFF' }}>
                                                    {daysOfWeek[0].slice(0, 2)}
                                                </Typography>
                                            }
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'rgb(255, 255, 255)',
                                                borderRadius: '10px', // Rounded corners
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                            onClick={() => handleActivityDaysChange(day.key, day.name)}
                                        />
                                    )}
                                </Box>
                            ))
                        }
                    </Box>
                ))}
            </Box>
        );
    };

    const [ timeMode, setTimeMode ] = useState("all-day")
    useEffect(() => {
        console.log("timeMode : ", timeMode);

        setSelectTimeToggle(timeMode!=='all-day');

        /*
            if setting to all-day then update all entries
            otherwise if setting to per-day or multi-day see if there
            are currently assigned values to selectedActivityBeginTime and
            selectedActivityEndTime and populate those values
         */
        setSelectedActivityDates(prev => {
            if (timeMode === 'all-day') {
                // All entries marked all day
                return prev.map(entry => ({
                    ...entry,
                    "all-day": true,
                    begin_time: null,
                    end_time: null,
                }));
            }

            if (timeMode === 'multi-day' && prev.length > 1) {
                // Sort chronologically
                const sorted = [...prev].sort((a, b) =>
                    dayjs(a.date).isBefore(dayjs(b.date)) ? -1 : 1
                );

                return sorted.map((entry, index) => {
                    if (index === 0) {
                        return {
                            ...entry,
                            "all-day": false,
                            begin_time: selectedActivityBeginTime?.format('h:mm A') || null,
                            end_time: null,
                        };
                    } else if (index === sorted.length - 1) {
                        return {
                            ...entry,
                            "all-day": false,
                            begin_time: null,
                            end_time: selectedActivityEndTime?.format('h:mm A') || null,
                        };
                    } else {
                        return {
                            ...entry,
                            "all-day": true,
                            begin_time: null,
                            end_time: null,
                        };
                    }
                });
            }


            // Default fallback for per-day or unknown mode
            return prev.map(entry => ({
                ...entry,
                "all-day": false,
                begin_time: selectedActivityBeginTime?.format('h:mm A') || entry.begin_time,
                end_time: selectedActivityEndTime?.format('h:mm A') || entry.end_time,
            }));
        });

        setSelectedActivityDays(prev => {
            if (timeMode === 'all-day') {
                // All entries marked all day
                return prev.map(entry => ({
                    ...entry,
                    "all-day": true,
                    begin_time: null,
                    end_time: null,
                }));
            }

            if (timeMode === 'multi-day' && prev.length > 1) {
                // ✅ Sort using extracted numeric index
                const sorted = [...prev].sort((a, b) => {
                    const aKey = Object.keys(a).find(k => k.startsWith("day "));
                    const bKey = Object.keys(b).find(k => k.startsWith("day "));
                    const aIndex = aKey ? parseInt(aKey.replace('day ', ''), 10) : 0;
                    const bIndex = bKey ? parseInt(bKey.replace('day ', ''), 10) : 0;
                    return aIndex - bIndex;
                });

                return sorted.map((entry, index) => {
                    if (index === 0) {
                        return {
                            ...entry,
                            "all-day": false,
                            begin_time: selectedActivityBeginTime?.format('h:mm A') || null,
                            end_time: null,
                        };
                    } else if (index === sorted.length - 1) {
                        return {
                            ...entry,
                            "all-day": false,
                            begin_time: null,
                            end_time: selectedActivityEndTime?.format('h:mm A') || null,
                        };
                    } else {
                        return {
                            ...entry,
                            "all-day": true,
                            begin_time: null,
                            end_time: null,
                        };
                    }
                });
            }


            // Default fallback for per-day or unknown mode
            return prev.map(entry => ({
                ...entry,
                "all-day": false,
                begin_time: selectedActivityBeginTime?.format('h:mm A') || entry.begin_time,
                end_time: selectedActivityEndTime?.format('h:mm A') || entry.end_time,
            }));
        });
    }, [timeMode]);


    const [selectedAttendees, setSelectedAttendees] = useState([]); // Attendees selection
    useEffect(() => {
        // 1. Fetch your event participants cleanly
        const globalAttendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;
        console.log("Global attendees found: ", globalAttendees);

        if (globalAttendees && globalAttendees.length > 0) {
            const filtered = globalAttendees
                .filter((att) => att.role !== 'planner')
                .map((att) => ({
                    id: att.id,
                    cost: 0,
                    is_business_expense: false,
                    business_expense_amount_authorized: 0,
                    business_expense_amount_authorized_by: "",
                    business_expense_amount_authorized_timestamp: 0,
                    business_expense_amount: 0,
                    business_expense_paid: 0,
                    business_expense_reference_id: "",
                }));

            // 2. Set your inner form content
            setActivity(prevState => ({
                ...prevState,
                attendees: filtered
            }));
        }
    }, []);

    useEffect(() => {
        if (!activity?.attendees || activity.attendees.length === 0) {
            setSelectedAttendees([]);
            return;
        }

        // Combine global store information and custom reference sources safely
        const currentGlobalList = PA_GlobalObject?.Planning?.attendees || [];

        const populatedList = activity.attendees.map((actAttendee) => {
            // Try finding their personal info bundle from the live store first, fallback to the reference array
            return currentGlobalList.find((att) => att.id === actAttendee.id) ||
                attendeesReferenceArray.find((att) => att.id === actAttendee.id);
        }).filter(Boolean); // Cleans out unmatched reference keys cleanly

        setSelectedAttendees(populatedList);
    }, [activity.attendees, PA_GlobalObject?.Planning?.attendees, attendeesReferenceArray]);

    const [showSelector, setShowSelector] = useState(false);
    const [tempSelected, setTempSelected] = useState([]);
    // Filter and group attendees (similar to your existing logic)
    const groupedAttendees = {
        'Event Attendees': usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees
            .filter(a => !a.planner && !selectedAttendees.some(sel => sel.id === a.id)),

        'Other Contacts': attendeesReferenceArray
            .filter(a =>
                !a.planner &&
                !usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees.some(ea => ea.id === a.id) &&
                !selectedAttendees.some(sel => sel.id === a.id) &&
                !a.isSample
            ),

        'Sample Attendees': attendeesReferenceArray
            .filter(a =>
                !a.planner &&
                !usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees.some(ea => ea.id === a.id) &&
                !selectedAttendees.some(sel => sel.id === a.id) &&
                a.isSample
            ),
    };
    const toggleTemp = (id) => {
        setTempSelected((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };
    useEffect(() => {
        console.log("tempSelected : ", tempSelected);
    }, [tempSelected]);
    const handleDone = () => {
        const globalStore = usePA_GlobalStore.getState();
        const globalAttendees = globalStore.PA_GlobalObject.Planning.attendees;

        const newGlobalAttendees = [...globalAttendees];

        // 🟢 FIXED: Start with what's ALREADY in the activity, don't wipe it out!
        const updatedActivityAttendees = [...activity.attendees];
        const updatedSelectedAttendees = [...selectedAttendees];

        let modified = false;

        tempSelected.forEach((_attendee_id) => {
            const isAlreadyInActivity = updatedActivityAttendees.some(a => a.id === _attendee_id);
            const isAlreadySelected = updatedSelectedAttendees.some(a => a.id === _attendee_id);
            const newAttendee = attendeesReferenceArray.find(a => String(a.id) === String(_attendee_id));

            if (!newAttendee) {
                console.error(`Attendee with ID ${_attendee_id} not found.`);
                return;
            }

            // Add to global context if not already there
            if (!globalAttendees.some(a => a.id === _attendee_id)) {
                newGlobalAttendees.push(newAttendee);
                modified = true;
            }

            // Add to selected attendees list if not already there
            if (!isAlreadySelected) {
                updatedSelectedAttendees.push(newAttendee);
            }

            // Add to activity attendees list if not already there
            if (!isAlreadyInActivity) {
                updatedActivityAttendees.push({
                    id: _attendee_id,
                    cost: 0,
                    is_business_expense: false,
                    business_expense_amount_authorized: 0,
                    business_expense_amount_authorized_by: "",
                    business_expense_amount_authorized_timestamp: 0,
                    business_expense_amount: 0,
                    business_expense_paid: 0,
                    business_expense_reference_id: "",
                });
            }
        });

        // Handle updating global store context if a brand-new external contact was added
        if (modified) {
            set_PA_GlobalObject(prev => ({
                ...prev,
                Planning: {
                    ...prev.Planning,
                    attendees: newGlobalAttendees
                }
            }));
        }

        // If assigning equal cost, recalculate split values across the newly expanded array pool
        if (activity.assign_equal) {
            const activityCost = parseFloat(activity.amount_total || 0);
            const numberOfAttendees = updatedActivityAttendees.length;

            if (numberOfAttendees > 0) {
                const baseCost = parseFloat((Math.floor((activityCost / numberOfAttendees) * 100) / 100).toFixed(2));
                const remainder = parseFloat((activityCost - baseCost * numberOfAttendees).toFixed(2));

                updatedActivityAttendees.forEach((attendee, i) => {
                    attendee.cost = baseCost.toFixed(2);
                    if (i === numberOfAttendees - 1) {
                        attendee.cost = (baseCost + remainder).toFixed(2);
                    }
                });
            }
        }

        console.log("setting the activity attendees : ", updatedActivityAttendees);
        setActivity(prev => ({
            ...prev,
            attendees: updatedActivityAttendees,
        }));

        setSelectedAttendees(updatedSelectedAttendees);

        // Cleanup states cleanly
        setTempSelected([]);
        setShowSelector(false);
    };

    const handleParticipantsToggle = (_attendee_id) => () => {
        console.log("_attendee_id : "+_attendee_id);

        //see if this Attendee needs to be added or removed
        const index = activity["attendees"].findIndex(item => item.id === _attendee_id);
        console.log("index : "+index);

        let updatedList = [...activity["attendees"]];
        console.log("updatedList : ",updatedList);
        if (index !== -1) {
            // Remove attendee from activity list
            console.log("Remove attendee from activity list");
            updatedList.splice(index, 1);

        } else {
            console.log("Add attendee to activity list");
            // Find the attendee in the reference array
            const newAttendee = attendeesReferenceArray.find(
                (attendee) => String(attendee.id) === String(_attendee_id));

            console.log("Found attendee to add");

            if (!newAttendee) {
                console.error(`Attendee with ID ${_attendee_id} not found.`);
                return;
            }

            console.log("Add to global context if not already present");
            // Add to global context if not already present
            const globalAttendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;
            if (!globalAttendees.some(att => att.id === _attendee_id)) {
                set_PA_GlobalObject(prev => ({
                    Planning: {
                        ...prev.Planning,
                        attendees: [...prev.Planning.attendees, newAttendee],
                    },
                }));
            }

            // Add the attendee to the activity attendee list
            const attendeeWithCost = {
                id: _attendee_id,
                cost: 0,
                is_business_expense: false,
                business_expense_amount_authorized: 0,
                business_expense_amount_authorized_by: "",
                business_expense_amount_authorized_timestamp: 0,
                business_expense_amount: 0,
                business_expense_paid: 0,
                business_expense_reference_id: "",
            };
            updatedList = [...activity.attendees, attendeeWithCost];
        }

        console.log("the completed updatedList : ",updatedList);

        setActivity(prevState => ({
            ...prevState,
            attendees: updatedList
        }));

        console.log("now update the selectedAttendees : ", selectedAttendees);
        setSelectedAttendees(() => {
            return updatedList
                .map((_att) => attendeesReferenceArray.find((att) => att.id === _att.id)) // Ensure return value
                .filter(Boolean); // Remove any `undefined` values in case no match is found
        });
    };

    const handleTabLocationChange  = (event, newValue) => {
        console.log("handleTabLocationChange ");
        setTabValueLocation(newValue);
    };

    // State for location
    const [tabValueLocation, setTabValueLocation] = useState("locations");

    const [activityLocation, setActivityLocation] = useState(new PALocation());
    useEffect(() => {
        console.log("an update to the Activity Location : ", activityLocation);
        setActivity((prev) => ({
            ...prev,
            location: activityLocation
        }));
    }, [activityLocation]);

    // Handle field changes with one reusable function
    const handleLocationFieldChange = (field) => (e) => {
        const value = e.target.value;
        setActivityLocation((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const [imagesToAdd, setImagesToAdd] = useState([]);
    const onDrop = useCallback(acceptedFiles => {
        acceptedFiles.forEach((file, index) => {
            // Ensure file type is valid
            if (!file.type || file.type === "0") {
                console.error(`Skipped "${file.name}" due to an invalid MIME type.`);
                return;
            }

            const validTypes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
            if (!validTypes.includes(file.type)) {
                console.error(`Skipped "${file.name}" due to an invalid file type: ${file.type}`);
                return;
            }

            const reader = new FileReader()
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {

                const new_photo = new Photo();

                //make sure a unique id
                new_photo.id = new_photo.id + index;

                new_photo.event_id = PA_GlobalObject.Planning.id;
                new_photo.attendee_id = Account.id;

                new_photo.file_name = file.name;
                new_photo.file_type = file.type;
                new_photo.file_size = file.size;
                new_photo.full_data = reader.result;

                new_photo.link_with_sections = [{
                    section: 'activities',
                    section_id: activity.id
                }];

                console.log("new_photo : ", new_photo);

                setImagesToAdd(prevImages => [...prevImages, new_photo]);
            }
            reader.readAsDataURL(file)
        })
    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        maxFiles: 30,
        accept: {
            "image/jpeg": [],
            "image/png": [],
            "image/gif": [],
            "image/webp": [],
            "application/pdf": [],
        },
    });

    function handleCaptionChange(value, index) {
        setImagesToAdd(prev => {
            const updated = [...prev];
            updated[index].caption = value;
            return updated;
        });
    }

    // Function to toggle the public property of an image data object
    function togglePublic(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].private = !updatedImages[index].private;
            return updatedImages;
        });
    }
    // Function to toggle the sharable property of an image data object
    function toggleSharable(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].sharable = !updatedImages[index].sharable;

            // Ensure email list is initialized when sharable is enabled
            if (updatedImages[index].sharable && !updatedImages[index].share_with) {
                updatedImages[index].share_with = [];
            }

            return updatedImages;
        });
    }
    function handleEmailInputChange(event, index) {
        if (event.key === "Enter") {
            event.preventDefault();
            const newEmail = event.target.value.trim();

            if (newEmail && /\S+@\S+\.\S+/.test(newEmail)) { // Simple email validation
                setImagesToAdd(prevImages => {
                    const updatedImages = [...prevImages];
                    updatedImages[index].share_with.push(newEmail);
                    return updatedImages;
                });

                event.target.value = ""; // Clear input after adding
            }
        }
    }
    function removeEmail(imageIndex, emailIndex) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[imageIndex].share_with.splice(emailIndex, 1);
            return updatedImages;
        });
    }
    // Function to toggle the photo_album property of an image data object
    function togglePhotoAlbum(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages[index].photo_album = !updatedImages[index].photo_album;
            return updatedImages;
        });
    }
    function removeImage(index) {
        setImagesToAdd(prevImages => {
            const updatedImages = [...prevImages];
            updatedImages.splice(index, 1);
            return updatedImages;
        });
    }



    async function onSubmit() {
        console.log("📝 Adding activity:", activity);
        const newActivities = [];

        // Get an unshakeable single-point truth snapshot right now
        const globalStateSnapshot = usePA_GlobalStore.getState().PA_GlobalObject;
        const planningId = globalStateSnapshot?.Planning?.id;
        const planningStatus = globalStateSnapshot?.Planning?.status;
        const globalAttendees = globalStateSnapshot?.Planning?.attendees || [];
        const planningDates = globalStateSnapshot?.Planning?.time_table?.dates || [];

        if (!planningId) {
            console.error("🛑 Cannot submit activity: Planning object context ID is missing.");
            return;
        }

        // Helper to safely deep clone base metadata properties to avoid shared reference collisions
        const cloneBaseActivity = () => ({
            ...activity,
            title: activityTitle,
            attendee_photos: activity.attendee_photos ? [...activity.attendee_photos] : []
        });

        // 📅 DATE PATTERN HANDLING
        if (selectedActivityDates.length > 0) {
            const sortedDates = [...selectedActivityDates].sort((a, b) =>
                dayjs(a.date).unix() - dayjs(b.date).unix()
            );

            if (sortedDates.length === 1) {
                const dayIndex = planningDates.findIndex(d => d.date === sortedDates[0].date);
                const single = cloneBaseActivity();

                const _uid = PAAttendee.generateRandomString(10);
                single.id = _uid;
                single.temp_id = _uid;

                single.time_table = {
                    dates: [sortedDates[0]],
                    days: [{
                        [`day ${dayIndex + 1}`]: dayjs(sortedDates[0].date).format("dddd"),
                        'all-day': sortedDates[0]['all-day'],
                        'begin_time': sortedDates[0]['begin_time'],
                        'end_time': sortedDates[0]['end_time'],
                        'notes': sortedDates[0]['notes'],
                    }]
                };
                newActivities.push(single);
            } else {
                const isMultiDay = timeMode === "multi-day" && areDatesConsecutive(sortedDates);

                if (isMultiDay) {
                    const multi = cloneBaseActivity();
                    const _uid = PAAttendee.generateRandomString(10);
                    multi.id = _uid;
                    multi.temp_id = _uid;

                    multi.time_table = {
                        dates: sortedDates,
                        days: sortedDates.map(entry => {
                            const dayIndex = planningDates.findIndex(d => d.date === entry.date);
                            return {
                                [`day ${dayIndex + 1}`]: dayjs(entry.date).format("dddd"),
                                'all-day': entry['all-day'],
                                'begin_time': entry['begin_time'],
                                'end_time': entry['end_time'],
                                'notes': entry['notes'],
                            };
                        })
                    };
                    newActivities.push(multi);
                } else {
                    for (let entry of sortedDates) {
                        const perDay = cloneBaseActivity();
                        const _temp = PAAttendee.generateRandomString(10);
                        perDay.temp_id = _temp;
                        perDay.id = _temp;

                        const dayIndex = planningDates.findIndex(d => d.date === entry.date);
                        perDay.time_table = {
                            dates: [entry],
                            days: [{
                                [`day ${dayIndex + 1}`]: dayjs(entry.date).format("dddd"),
                                'all-day': entry['all-day'],
                                'begin_time': entry['begin_time'],
                                'end_time': entry['end_time'],
                                'notes': entry['notes'],
                            }]
                        };
                        newActivities.push(perDay);
                    }
                }
            }
        }
        // 🗓️ DAY PATTERN HANDLING
        else if (selectedActivityDays.length > 0) {
            const sortedDays = [...selectedActivityDays].sort((a, b) => {
                const aKey = Object.keys(a).find(k => k.startsWith("day "));
                const bKey = Object.keys(b).find(k => k.startsWith("day "));
                const aIndex = aKey ? parseInt(aKey.replace('day ', ''), 10) : 0;
                const bIndex = bKey ? parseInt(bKey.replace('day ', ''), 10) : 0;
                return aIndex - bIndex;
            });

            if (sortedDays.length === 1) {
                const oneDay = cloneBaseActivity();
                const _uid = PAAttendee.generateRandomString(10);
                oneDay.id = _uid;
                oneDay.temp_id = _uid;

                oneDay.time_table = { dates: [], days: sortedDays };
                newActivities.push(oneDay);
            } else {
                const isMultiDay = timeMode === "multi-day" && areDayIndexesConsecutive(sortedDays);

                if (isMultiDay) {
                    const multi = cloneBaseActivity();
                    const _uid = PAAttendee.generateRandomString(10);
                    multi.id = _uid;
                    multi.temp_id = _uid;

                    multi.time_table = { dates: [], days: sortedDays };
                    newActivities.push(multi);
                } else {
                    for (let entry of sortedDays) {
                        const perDay = cloneBaseActivity();
                        const _uid = PAAttendee.generateRandomString(10);
                        perDay.id = _uid;
                        perDay.temp_id = _uid;

                        perDay.time_table = { dates: [], days: [entry] };
                        newActivities.push(perDay);
                    }
                }
            }
        }

        // 🛑 FALLBACK POOL ASSIGNMENT
        if (newActivities.length === 0){
            const baseFallback = cloneBaseActivity();
            const _uid = PAAttendee.generateRandomString(10);
            baseFallback.id = _uid;
            baseFallback.temp_id = _uid;
            newActivities.push(baseFallback);
        }

        // 👥 ATTENDEE MODIFICATION CHECKS
        const attendeeChanges = [];
        selectedAttendees.forEach((_att) => {
            if (!globalAttendees.some(att => att.id === _att.id)) {
                attendeeChanges.push(_att.id);
            }
        });

        const newAttendees = attendeeChanges
            .map((_att_id) => attendeesReferenceArray.find((att) => att.id === _att_id))
            .filter(Boolean);

        // 📸 IMAGE MAP INJECTIONS (Injecting into ALL relative instances generated for full resilience)
        if (imagesToAdd.length > 0 && newActivities.length > 0){
            newActivities.forEach((actInstance) => {
                if (!actInstance.attendee_photos) {
                    actInstance.attendee_photos = [];
                }
                imagesToAdd.forEach((_photo) => {
                    actInstance.attendee_photos.push({ photo_id: _photo.id });
                });
            });
        }

        // Persistent IndexedDB database writes
        for (const photo of imagesToAdd) {
            try {
                await addEventPhoto(photo);
                console.log(`Photo saved locally: ${photo.file_name}`);
            } catch (err) {
                console.error("Failed to store photo in browser DB:", err);
            }
        }

        console.log("✅ Final validated execution package:", newActivities);

        // 🚀 UNIFIED CONTEXT STATE WRITE BACK
        set_PA_GlobalObject(prev => {
            const existingAttendees = prev.Planning?.attendees || [];
            const existingActivities = prev.Planning?.activities || [];

            // Dedup new attendees map list in local state arrays
            const filteredNewAttendees = newAttendees.filter(
                newA => !existingAttendees.some(ea => ea.id === newA.id)
            );

            return {
                ...prev,
                Planning: {
                    ...prev.Planning,
                    attendees: [...existingAttendees, ...filteredNewAttendees],
                    activities: [...existingActivities, ...newActivities]
                }
            };
        });

        // ⚡ REALTIME DISPATCH SYNCING
        // Fire real-time attendee payload mapping socket updates if necessary
        if (newAttendees.length > 0) {
            /*
            sendSocketMessage({
                action: "E_updateEventAttendees",
                event_id: planningId,
                new_attendees: newAttendees
            });
            */
        }

        if (planningStatus !== 10) {
            newActivities.forEach((_activity) => {
                sendSocketMessage({
                    action: "E_addEventActivity_v2",
                    event_id: planningId,
                    activity: _activity
                });
            });
        }

        handlePromptChangeClose();
    }


    function handlePromptChangeClose() {
        navigate('/Planner/Activities');
    }

    const parseV2Address = (place) => {
        let _address_line = "", _address_city = "", _address_state = "", _address_zip = "", _address_country = "";

        // 🔀 DUAL PAYLOAD CAPTURE: Support new API (addressComponents) and classic API (address_components)
        const components = place.addressComponents || place.address_components || [];

        // Find country short code safely
        const _country_comp = components.find(c => c.types.includes("country"));
        const _country_code = _country_comp ? (_country_comp.shortText || _country_comp.short_name || "") : "";

        components.forEach((component) => {
            const types = component.types;
            // Support new API (longText / shortText) and classic API (long_name / short_name)
            const longVal = component.longText || component.long_name || "";
            const shortVal = component.shortText || component.short_name || "";

            if (types.includes("street_number")) {
                _address_line = longVal;
            } else if (types.includes("route")) {
                _address_line = _address_line ? `${_address_line} ${longVal}` : longVal;
            } else if (types.includes("locality")) {
                _address_city = longVal;
            } else if (types.includes("administrative_area_level_1")) {
                _address_state = (_country_code === "US") ? shortVal : longVal;
            } else if (types.includes("postal_code")) {
                _address_zip = longVal;
            } else if (types.includes("country")) {
                _address_country = shortVal;
            }
        });

        // Fallback if street number + route weren't parsed out
        if (!_address_line) {
            const fallbackFormatted = place.formattedAddress || place.formatted_address;
            if (fallbackFormatted) {
                _address_line = fallbackFormatted.split(',')[0].trim();
            }
        }
        return { _address_line, _address_city, _address_state, _address_zip, _address_country };
    };
    const handleUniversalSelect = (place, isBusiness) => {
        if (!place) return;

        // 🚀 DISMISS MOBILE KEYBOARD
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        // Keep the original instance for class methods (like photo.getURI)
        const originalPlace = place;

        // Some implementations wrap or expose a native toJSON()
        const rawPlace = typeof place.toJSON === 'function' ? place.toJSON() : place;
        console.log("the selected Place 111: ", rawPlace);

        const parsedAddr = parseV2Address(rawPlace);
        console.log("the parsedAddr 111: ", parsedAddr);

        // Shared Location Object Mapper with robust legacy cross-compatibility fallbacks
        const mapToPALocation = (p, parsed, livePlaceInstance) => {
            const loc = new PALocation();

            loc.Place = livePlaceInstance;

            // 1. Core ID & Name
            loc.google_place_id = p.id || p.place_id || "";
            loc.name = p.displayName?.text || p.displayName || p.name || "";

            // 2. Latitude & Longitude Extraction
            let latVal = null;
            let lngVal = null;
            if (p.location) {
                latVal = typeof p.location.lat === 'function' ? p.location.lat() : p.location.lat;
                lngVal = typeof p.location.lng === 'function' ? p.location.lng() : p.location.lng;
            } else if (p.geometry?.location) {
                latVal = typeof p.geometry.location.lat === 'function' ? p.geometry.location.lat() : p.geometry.location.lat;
                lngVal = typeof p.geometry.location.lng === 'function' ? p.geometry.location.lng() : p.geometry.location.lng;
            }
            loc.latitude = latVal;
            loc.longitude = lngVal;

            // 3. Addresses
            loc.formatted_address = p.formattedAddress || p.formatted_address || "";
            loc.address = parsed._address_line;
            loc.city = parsed._address_city;
            loc.state = parsed._address_state;
            loc.zip = parsed._address_zip;
            loc.country = parsed._address_country;

            // 4. Extended Metadata details
            loc.phone = p.internationalPhoneNumber || p.international_phone_number || p.formatted_phone_number || "";
            loc.types = p.types || [];
            loc.website = p.websiteURI || p.website || "";
            loc.price_level = p.priceLevel !== undefined ? p.priceLevel : p.price_level;
            loc.rating = p.rating;
            loc.total_ratings = p.userRatingCount || p.user_ratings_total || 0;

            // 5. Operating Hours Array Normalization
            loc.hours = p.regularOpeningHours?.weekdayDescriptions ||
                p.opening_hours?.weekday_text ||
                [];

            console.log("the selected address mapped perfectly: ", loc);
            return loc;
        };

        setActivityLocation(mapToPALocation(rawPlace, parsedAddr, originalPlace));
    };
    const {
        containerRef: locationRef,
        initAutocomplete: initUniversal,
        autocompleteInstance
    } = useGoogleAutocompleteUniversal(handleUniversalSelect);

    useEffect(() => {
        // try to (re)initialize/append the autocomplete
        if (tabValueLocation === "search" && locationRef.current) {
            initUniversal();
        }
    }, [tabValueLocation, locationRef.current]);



    return (

        <div className="activities-list-container">

            {/* --- NEW ACTIVITY FORM HEADER --- */}

            <Paper
                elevation={0}
                sx={{
                    p: '9.6px 9.6px 0px 9.6px',
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>

                    {/* Title Area - Locked to prevent compression */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flexShrink: 0 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', // Activity Amber/Gold Gradient
                            p: 0.8,
                            borderRadius: '8px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(245, 158, 11, 0.2)'
                        }}>
                            <i className="icon-list-heart" style={{ color: 'white', fontSize: '15px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{
                                fontWeight: 800,
                                color: '#1e293b',
                                fontSize: '0.85rem',
                                letterSpacing: -0.3,
                                whiteSpace: 'nowrap'
                            }}>
                                New Activity
                            </Typography>
                            <Typography variant="caption" sx={{
                                color: '#64748b',
                                fontWeight: 700,
                                fontSize: '0.6rem',
                                display: 'block',
                                lineHeight: 1
                            }}>
                                Create Itinerary Item
                            </Typography>
                        </Box>
                    </Box>

                    {/* Consolidated Actions Engine - Matching exactly your style spec */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flexShrink: 0 }}>

                        {/* Primary Action: Commit activity parameters */}
                        <Button
                            variant="contained"
                            onClick={onSubmit}
                            sx={{
                                bgcolor: '#10b981', // Emerald confirmation color
                                color: 'white',
                                fontWeight: 800,
                                fontSize: '0.75rem',
                                textTransform: 'none',
                                borderRadius: '8px',
                                px: 1.5,
                                height: '32px',
                                boxShadow: '0 4px 10px rgba(16, 185, 129, 0.2)',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    bgcolor: '#059669',
                                    boxShadow: '0 6px 14px rgba(16, 185, 129, 0.25)',
                                }
                            }}
                        >
                            Save
                        </Button>

                        <Divider orientation="vertical" variant="middle" flexItem sx={{ my: 0.5, borderColor: '#e2e8f0' }} />

                        {/* Dismissive Action: Abandon current layout */}
                        <IconButton
                            size="small"
                            onClick={handlePromptChangeClose}
                            sx={{
                                color: '#94a3b8',
                                borderRadius: '6px',
                                width: '28px',
                                height: '28px',
                                border: '1px solid #e2e8f0',
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    bgcolor: '#fef2f2',
                                    color: '#ef4444',
                                    borderColor: '#fca5a5'
                                }
                            }}
                        >
                            <i className="icon-cross" style={{ fontSize: '10px', fontWeight: 'bold' }} />
                        </IconButton>

                    </Box>
                </Box>
            </Paper>

            <div
                className="activities-list-add-item-container"
                style={{
                    height : props.showingPageHeader ? 'calc(100vh - 250px)' : 'calc(100vh - 180px)'
                }}
            >

                <Box sx={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>

                    {/* Title Section */}
                    <TextField
                        label="Activity Title"
                        value={activityTitle}
                        onChange={handleActivityTitleChange}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                            sx: {
                                borderRadius: '12px',
                                background: 'rgba(255, 255, 255, 0.5)',
                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#f09637' },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#f09637' }
                            }
                        }}
                        InputLabelProps={{
                            sx: { '&.Mui-focused': { color: '#f09637' } }
                        }}
                    />

                    {/* Date and Time Section */}
                    <Card
                        sx={{
                            borderRadius: '16px',
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(16px)',
                            WebkitBackdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.6)',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.05)',
                        }}
                    >
                        <CardHeader
                            title="Schedule"
                            subheader="Set a single date with a specific time window, or map out an itinerary spanning multiple days."
                            sx={{
                                p: '20px 20px 12px 20px',
                                "& .MuiCardHeader-title": { fontSize: "1rem", fontWeight: 700, color: '#1e293b' },
                                "& .MuiCardHeader-subheader": { fontSize: "12px", color: "text.secondary", mt: 0.5, lineHeight: 1.4 },
                            }}
                        />
                        <CardContent sx={{ paddingTop: '0' }}>

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isScheduled}
                                        onChange={handleIsScheduledToggle}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': { color: '#f09637' },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#f09637' }
                                        }}
                                    />
                                }
                                label={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155' }}>Schedule Timeline</Typography>}
                            />

                            {
                                isScheduled && (

                                    <>
                                        <TabContext sx={{ position:'relative'}} value={tabValueSchedule}>
                                            <Box sx={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.06)', mt: 1.5 }}>
                                                <TabList
                                                    sx={{
                                                        background: 'rgba(255, 255, 255, 0.6)',
                                                        '& .MuiTabs-indicator': { backgroundColor: '#f09637' }
                                                    }}
                                                    centered
                                                    variant="fullWidth"
                                                    onChange={handleTabScheduleChange}
                                                    aria-label="Schedule"
                                                >
                                                    <Tab label="Dates" value="dates" sx={{ fontSize: '13px', fontWeight: 700, '&.Mui-selected': { color: '#f09637' } }} />
                                                    <Tab label="Days" value="days" sx={{ fontSize: '13px', fontWeight: 700, '&.Mui-selected': { color: '#f09637' } }} />
                                                </TabList>
                                            </Box>
                                            <TabPanel value="dates" sx={{ padding: '24px 0' }}>
                                                <Box>
                                                    <DateCalendar
                                                        sx={{ width: 'auto' }}
                                                        value={calendarDate}
                                                        onChange={(newValue) => setCalendarDate(newValue)}
                                                        renderLoading={() => <DayCalendarSkeleton />}
                                                        showDaysOutsideCurrentMonth
                                                        slots={{ day: ServerDay }}
                                                        slotProps={{
                                                            day: {
                                                                planningData: usePA_GlobalStore.getState().PA_GlobalObject.Planning,
                                                            },
                                                        }}
                                                    />

                                                    {/* Category Legends */}
                                                    {PA_GlobalObject.Planning.meals.some(_meal => _meal.time_table?.dates?.length > 0) && (
                                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                                                            <Box
                                                                sx={{
                                                                    width: '8px',
                                                                    height: '8px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#FF6347',
                                                                }}
                                                            />
                                                            <Typography variant="caption">Meals</Typography>
                                                        </Box>
                                                    )}

                                                    {PA_GlobalObject.Planning.lodging.some(_l => _l.time_table?.dates?.length > 0) && (
                                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                                                            <Box
                                                                sx={{
                                                                    width: '8px',
                                                                    height: '8px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#32CD32',
                                                                }}
                                                            />
                                                            <Typography variant="caption">Lodging</Typography>
                                                        </Box>
                                                    )}

                                                    {PA_GlobalObject.Planning.activities.some(_a => _a.time_table?.dates?.length > 0) && (
                                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                                                            <Box
                                                                sx={{
                                                                    width: '8px',
                                                                    height: '8px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#FFD700',
                                                                }}
                                                            />
                                                            <Typography variant="caption">Activities</Typography>
                                                        </Box>
                                                    )}
                                                </Box>

                                            </TabPanel>
                                            <TabPanel value="days" sx={{ padding: '24px 0' }}>

                                                {/*
                                                    if there are Planning time_table days then show the calendar format days
                                                    otherwise, show the select boxes to choose the number of days and
                                                    which day it starts on
                                                */}

                                                {
                                                    eventHasDays ? (
                                                        <Box sx={{ marginBottom: '20px' }}>
                                                            {renderActivityDaysLayoutForBegin()}
                                                        </Box>
                                                    ) : (
                                                        <>
                                                            <Box sx={{ marginBottom: '20px' }}>
                                                                <TextField
                                                                    fullWidth
                                                                    id="event_date_days"
                                                                    label="Number of Days"
                                                                    value={activityDaysCount}
                                                                    onChange={handleActivityDaysCountChange}
                                                                    type="number"
                                                                />
                                                            </Box>
                                                            <Box sx={{ marginBottom: '20px' }}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="event-days-select-label">Starting On Day</InputLabel>
                                                                    <Select
                                                                        labelId="event-days-select-label"
                                                                        id="event_days_select"
                                                                        value={activityStartingOnDay}
                                                                        label="Starting On Day"
                                                                        onChange={handleActivityStartingOnChange}
                                                                    >
                                                                        <MenuItem value="">Not Selected</MenuItem>
                                                                        <MenuItem value="Sunday">Sunday</MenuItem>
                                                                        <MenuItem value="Monday">Monday</MenuItem>
                                                                        <MenuItem value="Tuesday">Tuesday</MenuItem>
                                                                        <MenuItem value="Wednesday">Wednesday</MenuItem>
                                                                        <MenuItem value="Thursday">Thursday</MenuItem>
                                                                        <MenuItem value="Friday">Friday</MenuItem>
                                                                        <MenuItem value="Saturday">Saturday</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            </Box>
                                                        </>
                                                    )
                                                }
                                            </TabPanel>
                                        </TabContext>

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={allDay}
                                                    onChange={handleAllDayToggle}
                                                    sx={{
                                                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#f09637' },
                                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#f09637' }
                                                    }}
                                                />
                                            }
                                            label={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155' }}>Assign time for this Activity</Typography>}
                                        />

                                        {allDay && (
                                            <>
                                                <ToggleButtonGroup
                                                    value={timeMode}
                                                    exclusive
                                                    onChange={(e, newMode) => { if (newMode !== null) setTimeMode(newMode); }}
                                                    orientation="vertical"
                                                    fullWidth
                                                    sx={{ mt: 2, mb: 2, gap: '6px', '& .MuiToggleButtonGroup-grouped': { border: '1px solid rgba(0,0,0,0.08) !important', borderRadius: '10px !important' } }}
                                                >
                                                    {[
                                                        { value: "all-day", label: "All Day for all selected dates" },
                                                        { value: "per-day", label: "One start and end time per day" },
                                                        ...((selectedActivityDates.length > 1 && areDatesConsecutive(selectedActivityDates)) || (selectedActivityDays.length > 1 && areDayIndexesConsecutive(selectedActivityDays))
                                                            ? [{ value: "multi-day", label: "Start on first date, end on last consecutive date (all day in between)" }]
                                                            : [])
                                                    ].map((option) => (
                                                        <ToggleButton
                                                            key={option.value}
                                                            value={option.value}
                                                            sx={{
                                                                justifyContent: 'flex-start', textTransform: 'none', px: 2, py: 1.5, fontSize: '13px', fontWeight: 500, color: 'text.primary',
                                                                transition: 'all 0.2s',
                                                                '&.Mui-selected': { backgroundColor: 'rgba(240, 150, 55, 0.12)', color: '#b35d00', borderColor: 'rgba(240,150,55,0.4) !important', fontWeight: 600 }
                                                            }}
                                                        >
                                                            {option.label}
                                                        </ToggleButton>
                                                    ))}
                                                </ToggleButtonGroup>

                                                {selectTimeToggle && (
                                                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 1 }}>
                                                        <FormControl fullWidth>
                                                            <TimePicker
                                                                label="Begin Time"
                                                                value={dayjs(selectedActivityBeginTime, 'hh:mm A')}
                                                                onChange={handleBeginTimeChange}
                                                                slotProps={{ textField: { size: 'small', sx: { '& .MuiOutlinedInput-root': { borderRadius: '10px', background: 'rgba(255,255,255,0.4)' } } } }}
                                                            />
                                                        </FormControl>
                                                        <FormControl fullWidth>
                                                            <TimePicker
                                                                label="End Time"
                                                                value={dayjs(selectedActivityEndTime, 'hh:mm A')}
                                                                onChange={handleEndTimeChange}
                                                                slotProps={{ textField: { size: 'small', sx: { '& .MuiOutlinedInput-root': { borderRadius: '10px', background: 'rgba(255,255,255,0.4)' } } } }}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                )}

                                            </>

                                        )}


                                        {/* 📝 REAL-TIME SCHEDULE SUMMARY BOX */}
                                        <Box
                                            sx={{
                                                backgroundColor: 'rgba(255, 255, 255, 0.45)',
                                                border: '1px solid rgba(255,255,255,0.5)',
                                                borderRadius: '12px',
                                                p: 2,
                                                mt: 2.5
                                            }}
                                        >
                                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, color: '#334155', fontSize: '13px' }}>
                                                Schedule Summary
                                            </Typography>
                                            <Stack spacing={0.5}>
                                                {tabValueSchedule === "dates" && selectedActivityDates.length > 0 && (
                                                    selectedActivityDates
                                                        .sort((a, b) => dayjs(a.date).diff(dayjs(b.date)))
                                                        .map((entry, index) => {
                                                            const formattedDate = dayjs(entry.date).format("ddd, MMM D");
                                                            let timeInfo = entry['all-day'] ? "All Day" : (entry.begin_time && entry.end_time ? `${entry.begin_time} to ${entry.end_time}` : (entry.begin_time ? `Starts ${entry.begin_time}` : (entry.end_time ? `Ends ${entry.end_time}` : "No time set")));
                                                            return (
                                                                <Box key={index} display="flex" justifyContent="space-between" sx={{ borderBottom: '1px solid rgba(0,0,0,0.04)', py: 1, '&:last-child': { border: 0 } }}>
                                                                    <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{formattedDate}</Typography>
                                                                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.secondary' }}>{timeInfo}</Typography>
                                                                </Box>
                                                            );
                                                        })
                                                )}

                                                {tabValueSchedule === "days" && selectedActivityDays.length > 0 && (
                                                    selectedActivityDays.map((entry, index) => {
                                                        let timeInfo = entry['all-day'] ? "All Day" : (entry.begin_time && entry.end_time ? `${entry.begin_time} to ${entry.end_time}` : (entry.begin_time ? `Starts ${entry.begin_time}` : (entry.end_time ? `Ends ${entry.end_time}` : "No time set")));
                                                        const dayKey = Object.keys(entry).find(k => k.startsWith("day "));
                                                        const dayLabel = dayKey ? `${entry[dayKey].slice(0, 3)}, ${dayKey}` : "Unknown Day";
                                                        return (
                                                            <Box key={index} display="flex" justifyContent="space-between" sx={{ borderBottom: '1px solid rgba(0,0,0,0.04)', py: 1, '&:last-child': { border: 0 } }}>
                                                                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{dayLabel}</Typography>
                                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.secondary' }}>{timeInfo}</Typography>
                                                            </Box>
                                                        );
                                                    })
                                                )}
                                            </Stack>
                                        </Box>

                                    </>
                                )
                            }

                        </CardContent>
                    </Card>

                    {/* 👥 PARTICIPANTS SYSTEM */}
                    <Card
                        sx={{
                            borderRadius: '16px',
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(16px)',
                            WebkitBackdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.6)',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.05)',
                        }}
                    >
                        <CardHeader
                            title="Participants"
                            subheader="Select which Attendees will be participating."
                            sx={{
                                p: '20px 20px 0 20px',
                                "& .MuiCardHeader-title": { fontSize: "1rem", fontWeight: 700, color: '#1e293b' },
                                "& .MuiCardHeader-subheader": { fontSize: "13px", color: "text.secondary", mt: 0.5 },
                            }}
                        />
                        <CardContent sx={{ pb: '16px !important' }}>
                            <List dense sx={{ width: '100%', bgcolor: 'transparent' }}>
                                {selectedAttendees
                                    .sort((a, b) => `${formatName(a.lname).toLowerCase()}, ${formatName(a.fname).toLowerCase()}`.localeCompare(`${formatName(b.lname).toLowerCase()}, ${formatName(b.fname).toLowerCase()}`))
                                    .map((_attendee, index) => {
                                        // Safe Fallback: Check structural lookup points
                                        const attendeeAvatar = attendeesReferenceArray.find((_att) => _att.id === _attendee.id) || _attendee;
                                        if (!_attendee) return null;

                                        return (
                                            <Box key={_attendee.id || index}>
                                                <ListItem
                                                    secondaryAction={
                                                        <Checkbox
                                                            edge="end"
                                                            onChange={handleParticipantsToggle(_attendee.id)}
                                                            checked={activity.attendees.some(item => item.id === _attendee.id)}
                                                            sx={{ '&.Mui-checked': { color: '#f09637' } }}
                                                        />
                                                    }
                                                    disablePadding
                                                >
                                                    <ListItemButton sx={{ py: 1, px: 1, borderRadius: '8px' }}>
                                                        <ListItemAvatar sx={{ minWidth: '42px' }}>
                                                            {_attendee.isSample ? (
                                                                <Chip label="SMPL" size="small" sx={{ bgcolor: "rgba(0,0,0,0.06)", color: "#555", fontWeight: "bold", fontSize: "10px", height: "18px", borderRadius: "4px" }} />
                                                            ) : (
                                                                <Avatar
                                                                    src={attendeeAvatar?.avatar?.preview || undefined}
                                                                    {...(!attendeeAvatar?.avatar?.preview ? stringAvatar(`${formatName(_attendee.fname)}, ${formatName(_attendee.lname)}`) : {})}
                                                                    sx={{
                                                                        width: 32, height: 32, fontSize: '13px', fontWeight: 700,
                                                                        border: `1.5px solid ${stringToColor(`${formatName(_attendee.fname)}, ${formatName(_attendee.lname)}`)}`,
                                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
                                                                    }}
                                                                />
                                                            )}
                                                        </ListItemAvatar>
                                                        <ListItemText primary={`${formatName(_attendee.lname)}, ${formatName(_attendee.fname)}`} primaryTypographyProps={{ fontSize: '14px', fontWeight: 500, color: '#334155' }} />
                                                    </ListItemButton>
                                                </ListItem>
                                                <Divider sx={{ opacity: 0.4 }} />
                                            </Box>
                                        );
                                    })}
                            </List>

                            {/* Selector Management Triggers - Secondary and Cancel Action buttons styled matching your design console logic */}
                            <Box display="flex" justifyContent="center" mt={2}>
                                {!showSelector ? (
                                    <Button
                                        variant="text"
                                        onClick={() => setShowSelector(true)}
                                        startIcon={<i className="icon-plus" style={{fontSize: '10px', fontWeight: 900}}/>}
                                        sx={{
                                            color: '#10b981',
                                            fontWeight: 800,
                                            fontSize: '0.72rem',
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            px: 1.5,
                                            height: '32px',
                                            '&:hover': { bgcolor: 'rgba(16, 185, 129, 0.06)' }
                                        }}
                                    >
                                        Add Attendees
                                    </Button>
                                ) : (
                                    <Box display="flex" gap={1} alignItems="center">
                                        <Button
                                            variant="contained"
                                            onClick={handleDone}
                                            sx={{
                                                bgcolor: '#10b981',
                                                color: 'white',
                                                fontWeight: 800,
                                                fontSize: '0.75rem',
                                                textTransform: 'none',
                                                borderRadius: '8px',
                                                px: 1.5,
                                                height: '32px',
                                                boxShadow: '0 4px 10px rgba(16, 185, 129, 0.2)',
                                                '&:hover': { bgcolor: '#059669' }
                                            }}
                                        >
                                            Done
                                        </Button>
                                        <Divider orientation="vertical" variant="middle" flexItem sx={{ borderColor: '#e2e8f0', mx: 0.5 }} />
                                        <IconButton
                                            size="small"
                                            onClick={() => setShowSelector(false)}
                                            sx={{
                                                color: '#94a3b8',
                                                borderRadius: '6px',
                                                width: '28px',
                                                height: '28px',
                                                border: '1px solid #e2e8f0',
                                                '&:hover': { bgcolor: '#fef2f2', color: '#ef4444', borderColor: '#fca5a5' }
                                            }}
                                        >
                                            <i className="icon-cross" style={{ fontSize: '10px', fontWeight: 'bold' }} />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>

                            {/* Collapsible Selection Grid */}
                            <Collapse in={showSelector}>
                                <Box sx={{ mt: 2.5, p: 1.5, background: 'rgba(255,255,255,0.35)', border: '1px solid rgba(0,0,0,0.06)', borderRadius: '12px' }}>
                                    {Object.entries(groupedAttendees).map(([group, attendees]) => (
                                        attendees.length > 0 && (
                                            <Box key={group} mb={2} sx={{ '&:last-child': { mb: 0 } }}>
                                                <Typography variant="subtitle2" sx={{ backgroundColor: "rgba(0,0,0,0.04)", px: 1.5, py: 0.5, borderRadius: '6px', fontSize: '11px', fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase' }}>
                                                    {group}
                                                </Typography>
                                                <List dense>
                                                    {attendees
                                                        .sort((a, b) => `${formatName(a.lname)}, ${formatName(a.fname)}`.localeCompare(`${formatName(b.lname)}, ${formatName(b.fname)}`))
                                                        .map((attendee) => (
                                                            <ListItem
                                                                key={attendee.id}
                                                                secondaryAction={<Checkbox edge="end" onChange={() => toggleTemp(attendee.id)} checked={tempSelected.includes(attendee.id)} sx={{ '&.Mui-checked': { color: '#f09637' } }} />}
                                                                disablePadding
                                                            >
                                                                <ListItemButton sx={{ borderRadius: '6px', py: 0.5 }}>
                                                                    <ListItemAvatar sx={{ minWidth: '38px' }}>
                                                                        <Avatar
                                                                            src={attendee.avatar?.preview || undefined}
                                                                            {...(!attendee.avatar?.preview ? stringAvatar(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`) : {})}
                                                                            sx={{ width: 28, height: 28, fontSize: '11px', fontWeight: 700, border: `1px solid ${stringToColor(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}` }}
                                                                        />
                                                                    </ListItemAvatar>
                                                                    <ListItemText primary={`${formatName(attendee.lname)}, ${formatName(attendee.fname)}`} primaryTypographyProps={{ fontSize: '13px', fontWeight: 500 }} />
                                                                </ListItemButton>
                                                            </ListItem>
                                                        ))}
                                                </List>
                                            </Box>
                                        )
                                    ))}
                                </Box>
                            </Collapse>
                        </CardContent>
                    </Card>

                    {/*  Location Section  */}
                    <Card
                        sx={{
                            borderRadius: '16px',
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(16px)',
                            WebkitBackdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.6)',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.05)',
                            // 🔥 CRITICAL FIX 1: Allow elements to escape the card boundaries
                            overflow: 'visible !important',
                            '& .MuiCardContent-root': {
                                overflow: 'visible !important'
                            }
                        }}
                    >
                        <CardHeader
                            title="Location"
                            subheader="Where the Activity is taking place."
                            sx={{
                                p: '20px 20px 0 20px',
                                "& .MuiCardHeader-title": { fontSize: "1rem", fontWeight: 700, color: '#1e293b' },
                                "& .MuiCardHeader-subheader": { fontSize: "13px", color: "text.secondary", mt: 0.5 },
                            }}
                        />
                        <CardContent sx={{ pb: '16px !important', overflow: 'visible !important' }}>
                            {activityLocation && (activityLocation.name || activityLocation.address) ? (
                                // 📍 ACTIVE LOCATION SELECTED
                                <Box
                                    sx={{
                                        mb: 2,
                                        p: 2,
                                        background: 'rgba(240, 150, 55, 0.06)',
                                        border: '1px dashed rgba(240, 150, 55, 0.3)',
                                        borderRadius: '12px',
                                        animation: 'fadeIn 0.3s ease-out'
                                    }}
                                >
                                    {/* add any images */}
                                    {
                                        activityLocation['Place'] && activityLocation['Place'].photos && activityLocation['Place'].photos.length > 0 ? (
                                            <div style={{ width: '100%', display: 'flex', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                                                {
                                                    activityLocation['Place'].photos.map((_photo, index) => {
                                                        // 🚀 COMPATIBILITY RESOLVER: Fall back through every version of Google Maps APIs
                                                        let imgSrc = "";
                                                        if (typeof _photo.getURI === 'function') {
                                                            imgSrc = _photo.getURI({ maxWidth: 150, maxHeight: 150 });
                                                        } else if (typeof _photo.getUrl === 'function') {
                                                            imgSrc = _photo.getUrl({ maxWidth: 150, maxHeight: 150 });
                                                        } else {
                                                            // Plain JS Object fallbacks for hydrated Database instances
                                                            imgSrc = _photo.url || _photo.absoluteUrl || "";
                                                        }

                                                        // Skip rendering if no source url could be safely parsed
                                                        if (!imgSrc) return null;

                                                        return (
                                                            <CardMedia
                                                                key={index}
                                                                component="img"
                                                                sx={{
                                                                    marginRight: '10px',
                                                                    marginBottom: '8px',
                                                                    borderRadius: '8px',
                                                                    maxHeight: '150px',
                                                                    width: 'auto',
                                                                    objectFit: 'cover',
                                                                    flexShrink: 0
                                                                }}
                                                                alt={`Location Photo ${index + 1}`}
                                                                image={imgSrc}
                                                            />
                                                        );
                                                    })
                                                }
                                            </div>
                                        ) : null
                                    }

                                    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#2c3e50' }}>
                                        {activityLocation.name || "Unnamed Location"}
                                    </Typography>
                                    {activityLocation.address && (
                                        <Typography sx={{ fontSize: '12px', color: 'text.secondary', mt: 0.5 }}>
                                            {activityLocation.address}
                                        </Typography>
                                    )}
                                    {(activityLocation.city || activityLocation.state || activityLocation.zip) && (
                                        <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
                                            {activityLocation.city || ''} {activityLocation.state || ''} {activityLocation.zip || ''}
                                        </Typography>
                                    )}
                                    {activityLocation.phone && (
                                        <Typography sx={{ fontSize: '12px', color: 'text.secondary', mt: 0.5 }}>
                                            <i className="icon-phone2" style={{ marginRight: '4px' }}/>
                                            {activityLocation.phone_prefix || ''} {activityLocation.phone}
                                        </Typography>
                                    )}

                                    {/* Actions bar inside location card */}
                                    {(activityLocation.website || (Array.isArray(activityLocation.hours) && activityLocation.hours.length > 0)) && (
                                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 1.5, pt: 1, borderTop: '1px solid rgba(0,0,0,0.04)' }}>
                                            {activityLocation.website && (
                                                <span onClick={() => window.open(activityLocation.website, '_blank')} style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 600, fontSize: '12px', textDecoration: 'underline' }}>
                                                    Website
                                                </span>
                                            )}
                                            {Array.isArray(activityLocation.hours) && activityLocation.hours.length > 0 && (
                                                <span onClick={() => alert(activityLocation.hours.map(l => l.replace(/12:00 AM/g, 'midnight').replace(/12:00 PM/g, 'noon')).join('\n'))} style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 600, fontSize: '12px', textDecoration: 'underline' }}>
                                                    View Hours
                                                </span>
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            ) : (
                                // 🔍 CLEAN EMPTY STATE PLACEHOLDER
                                <Box
                                    sx={{
                                        mb: 2,
                                        p: 2.5,
                                        background: 'rgba(0, 0, 0, 0.02)',
                                        border: '1px dashed rgba(0, 0, 0, 0.08)',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 0.5
                                    }}
                                >
                                    <i className="icon-map-pin" style={{ fontSize: '20px', color: '#94a3b8' }} />
                                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748b' }}>
                                        No location attached
                                    </Typography>
                                    <Typography sx={{ fontSize: '11px', color: '#94a3b8', textAlign: 'center' }}>
                                        Use the search tab or address entry below to add one.
                                    </Typography>
                                </Box>
                            )}

                            <TabContext value={tabValueLocation}>
                                <Box sx={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.06)', mt: 1 }}>
                                    <TabList
                                        sx={{ background: 'rgba(255, 255, 255, 0.6)', '& .MuiTabs-indicator': { backgroundColor: '#f09637' } }}
                                        centered
                                        variant="fullWidth"
                                        onChange={handleTabLocationChange}
                                        aria-label="Activity Location"
                                    >
                                        <Tab label="Search" value="search" sx={{ fontSize: '12px', fontWeight: 700, '&.Mui-selected': { color: '#f09637' } }} />
                                        <Tab label="Locations" value="locations" sx={{ fontSize: '12px', fontWeight: 700, '&.Mui-selected': { color: '#f09637' } }} />
                                        <Tab label="Address" value="address" sx={{ fontSize: '12px', fontWeight: 700, '&.Mui-selected': { color: '#f09637' } }} />
                                    </TabList>
                                </Box>

                                <TabPanel
                                    value="search"
                                    sx={{
                                        p: '16px 0 0 0',
                                        position: 'relative',

                                        // 🚀 THE FIXED FOOTPRINT SOLUTION
                                        // 40px (Input) + 220px (Max height of 5 Google items) = 260px total reserved structural space
                                        pb: '300px !important',

                                        // Ensure the card's overflow doesn't clip our reserved canvas space
                                        overflow: 'visible !important'
                                    }}
                                >
                                    {/* Input box for autocomplete */}
                                    <Box
                                        ref={locationRef}
                                        onTouchStart={(e) => e.stopPropagation()}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        // 🚀 DESKTOP ENTER KEY FIX: Intercept physical Enter keypress events
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.stopPropagation(); // Stop bubbling up to parent search listeners

                                                // Safely blur to close the keyboard once selection is complete
                                                if (document.activeElement instanceof HTMLElement) {
                                                    document.activeElement.blur();
                                                }
                                            }
                                        }}

                                        // 🚀 MOBILE "GO / SEARCH" SUBMIT FIX: Intercept virtual OS form submissions
                                        onSubmit={(e) => {
                                            e.preventDefault();  // Stop the page from trying to hard-reload
                                            e.stopPropagation(); // Stop the event from reaching the broken parent handler
                                        }}
                                        sx={{
                                            flex: 1,
                                            minHeight: '40px',
                                            width: '100%',
                                            overflow: 'visible !important',
                                            position: 'relative',
                                            zIndex: 1100,

                                            '& gmp-place-autocomplete': {
                                                width: '100%',
                                                display: 'block',
                                                colorScheme: 'light !important',
                                                backgroundColor: '#ffffff !important',
                                                borderRadius: '12px !important',
                                            },

                                            // Align the absolute dropdown menu beautifully within our reserved area
                                            '& .pac-container, & ~ .pac-container': {
                                                zIndex: '2000 !important',
                                                visibility: 'visible !important',
                                                display: 'block !important',
                                                boxShadow: 'none !important', // Optional: removes floating shadow since it has a dedicated home
                                                border: 'none !important',
                                                position: 'absolute !important',
                                                top: '100% !important',
                                                left: '0 !important',
                                                width: '100% !important'
                                            }
                                        }}
                                    />
                                </TabPanel>

                                <TabPanel value="locations" sx={{ p: '16px 0 0 0' }}>
                                    <ActivityAddLocationTab activityLocation={activityLocation} setActivityLocation={setActivityLocation} />
                                </TabPanel>

                                <TabPanel value="address" sx={{ p: '16px 0 0 0', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    {["name", "address", "city", "state", "zip", "country"].map((field) => (
                                        <TextField
                                            key={field}
                                            label={field.charAt(0).toUpperCase() + field.slice(1).replace('zip', 'Zip Code')}
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={activityLocation?.[field] || ""}
                                            onChange={handleLocationFieldChange(field)}
                                            InputProps={{ sx: { borderRadius: '10px', background: 'rgba(255,255,255,0.4)' } }}
                                        />
                                    ))}
                                </TabPanel>
                            </TabContext>
                        </CardContent>
                    </Card>

                    {/* 📸 PHOTO UPLOAD SYSTEM */}
                    <Card
                        sx={{
                            borderRadius: '16px',
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(16px)',
                            WebkitBackdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.6)',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.05)',
                            overflow: 'visible !important',
                            '& .MuiCardContent-root': {
                                overflow: 'visible !important'
                            }
                        }}
                    >
                        <CardHeader
                            title="Photos"
                            subheader={dataArray.authenticated ? "Add photos related to this Activity" : null}
                            action={!dataArray.authenticated ? <IconButton size="small" sx={{ color: '#d32f2f' }}><i className="icon-lock2" style={{ fontSize: '16px' }} /></IconButton> : null}
                            sx={{
                                p: '20px 20px 0 20px',
                                "& .MuiCardHeader-title": { fontSize: "1rem", fontWeight: 700, color: '#1e293b' },
                                "& .MuiCardHeader-subheader": { fontSize: "13px", color: "text.secondary", mt: 0.5 },
                            }}
                        />
                        <CardContent sx={{ pb: '16px !important' }}>
                            {dataArray.authenticated ? (
                                <>
                                    {/* Drag and Drop Zone Container */}
                                    <Box
                                        {...getRootProps()}
                                        sx={{
                                            border: "2px dashed rgba(0,0,0,0.15)",
                                            p: 3,
                                            textAlign: "center",
                                            cursor: "pointer",
                                            borderRadius: "12px",
                                            background: 'rgba(0,0,0,0.01)',
                                            transition: 'all 0.2s',
                                            '&:hover': { borderColor: '#f09637', bgcolor: 'rgba(240,150,55,0.02)' }
                                        }}
                                    >
                                        <input {...getInputProps()} />
                                        <i className="icon-image" style={{ fontSize: '28px', color: '#94a3b8', display: 'block', marginBottom: '6px' }} />
                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: 'text.secondary' }}>
                                            {isDragActive ? "Drop files here..." : "Drag & drop photos here, or click to select"}
                                        </Typography>
                                    </Box>

                                    {/* Uploaded Images Render Stack */}
                                    {imagesToAdd && imagesToAdd.map((imageData, index) => (
                                        <Card key={index} sx={{ mt: 2, borderRadius: '12px', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 4px 12px rgba(0,0,0,0.04)' }}>
                                            <CardMedia component="img" src={imageData.full_data} alt={`Image ${index + 1}`} sx={{ maxHeight: 200, objectFit: 'cover' }} />
                                            <CardContent sx={{ p: 2 }}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Add a caption"
                                                    value={imageData.caption || ""}
                                                    onChange={(e) => handleCaptionChange(e.target.value, index)}
                                                    InputProps={{ sx: { borderRadius: '8px' } }}
                                                />

                                                {/* Toggle Configuration Panels styled matching unified segment buttons layout */}
                                                {[
                                                    { label: "Share with Attendees", desc: "Share with Event attendees or just keep the photo to yourself.", value: !imageData.private, setter: () => togglePublic(index), yesText: "YES", noText: "NO" },
                                                    { label: "Share with Internet", desc: "A link will be generated for you to share. Expires 30 days after Event ends.", value: imageData.sharable, setter: () => toggleSharable(index), yesText: "Share", noText: "Don't Share" },
                                                    { label: "Include in Photo Album", desc: "Make your Event cover image more memorable.", value: imageData.photo_album, setter: () => togglePhotoAlbum(index), yesText: "YES", noText: "NO" }
                                                ].map((cfg, cIdx) => (
                                                    <Box key={cIdx} sx={{ mt: 2, pt: 1.5, borderTop: '1px solid rgba(0,0,0,0.04)' }}>
                                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                                                            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#334155' }}>{cfg.label}</Typography>
                                                            <ButtonGroup variant="text" sx={{ background: 'rgba(0,0,0,0.03)', p: '2px', borderRadius: '6px' }}>
                                                                <Button onClick={cfg.setter} sx={{ fontSize: '10px', fontWeight: 700, px: 1.5, py: 0.25, bgcolor: cfg.value ? 'white' : 'transparent', color: cfg.value ? '#1976d2' : 'text.secondary', boxShadow: cfg.value ? '0 2px 4px rgba(0,0,0,0.04)' : 'none', '&:hover': { bgcolor: 'white' } }}>{cfg.yesText}</Button>
                                                                <Button onClick={cfg.setter} sx={{ fontSize: '10px', fontWeight: 700, px: 1.5, py: 0.25, bgcolor: !cfg.value ? 'white' : 'transparent', color: !cfg.value ? '#1976d2' : 'text.secondary', boxShadow: !cfg.value ? '0 2px 4px rgba(0,0,0,0.04)' : 'none', '&:hover': { bgcolor: 'white' } }}>{cfg.noText}</Button>
                                                            </ButtonGroup>
                                                        </Box>
                                                        <Typography sx={{ fontSize: '11px', color: 'text.secondary', lineHeight: 1.3 }}>{cfg.desc}</Typography>
                                                    </Box>
                                                ))}

                                                {/* Dynamic Sharable Target Emails */}
                                                {imageData.sharable && (
                                                    <Box sx={{ mt: 2, p: 1.5, background: 'rgba(0,0,0,0.02)', borderRadius: '8px' }}>
                                                        <Typography sx={{ fontSize: "12px", fontWeight: 600, color: '#334155' }}>Target recipient emails:</Typography>
                                                        <input
                                                            type="email"
                                                            placeholder="Type email and press Enter"
                                                            onKeyPress={(event) => handleEmailInputChange(event, index)}
                                                            style={{ width: '100%', padding: '8px 12px', marginTop: '6px', border: '1px solid rgba(0,0,0,0.15)', borderRadius: '6px', fontSize: '13px' }}
                                                        />
                                                        {imageData.share_with?.length > 0 && (
                                                            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                                                                {imageData.share_with.map((email, emailIndex) => (
                                                                    <Chip key={emailIndex} label={email} onDelete={() => removeEmail(index, emailIndex)} size="small" sx={{ backgroundColor: "rgba(25, 118, 210, 0.12)", fontWeight: 600, color: '#1976d2', borderRadius: '6px' }} />
                                                                ))}
                                                            </Box>
                                                        )}
                                                    </Box>
                                                )}
                                            </CardContent>
                                            <CardActions sx={{ justifyContent: "flex-end", bgcolor: 'rgba(0,0,0,0.01)', borderTop: '1px solid rgba(0,0,0,0.03)', px: 2, py: 0.5 }}>
                                                <IconButton size="small" sx={{ color: "#d32f2f" }} onClick={() => removeImage(index)}><i className="icon-trash" style={{ fontSize: '14px' }} /></IconButton>
                                            </CardActions>
                                        </Card>
                                    ))}
                                </>
                            ) : (
                                <Typography sx={{ py: 2, fontSize: "13px", fontWeight: 500 }} color="text.secondary" align="center">
                                    You must be logged in to add photos.
                                </Typography>
                            )}
                        </CardContent>
                    </Card>

                    {/* 📝 NOTES SYSTEM */}
                    <Card
                        sx={{
                            borderRadius: '16px',
                            background: 'rgba(255, 255, 255, 0.4)',
                            backdropFilter: 'blur(16px)',
                            WebkitBackdropFilter: 'blur(16px)',
                            border: '1px solid rgba(255, 255, 255, 0.6)',
                            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.05)',
                        }}
                    >
                        <CardHeader
                            title="Notes"
                            sx={{ p: '20px 20px 0 20px', "& .MuiCardHeader-title": { fontSize: "1rem", fontWeight: 700, color: '#1e293b' } }}
                        />
                        <CardContent sx={{ pb: '20px !important' }}>
                            <TextField
                                label="Notes"
                                value={activity.notes}
                                onChange={(e) => setActivity({ ...activity, notes: e.target.value })}
                                multiline
                                rows={4}
                                fullWidth
                                InputProps={{
                                    sx: {
                                        borderRadius: '12px',
                                        background: 'rgba(255, 255, 255, 0.5)',
                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#f09637' },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#f09637' }
                                    }
                                }}
                                InputLabelProps={{
                                    sx: { '&.Mui-focused': { color: '#f09637' } }
                                }}
                            />
                        </CardContent>
                    </Card>

                </Box>
            </div>
        </div>
    )
}


export default ActivitiesAddNew;
